import styled from 'styled-components'

import { useHapticFeedback } from '@blade/ui-kit'
import { CurrencyListItem } from '@root/entities/currency/ui'
import { AmountFormatted } from '@root/shared/core/format'

import type { CurrencyWithBalance } from '../atoms'
import type { CurrencyModel } from '@root/entities/currency'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  currency: CurrencyWithBalance
  onCurrencySelect?: (currency: CurrencyModel) => void
} & ClassNameProps

export const CurrencySelectorItem: React.FC<Props> = ({
  currency,
  onCurrencySelect,
}) => {
  const haptics = useHapticFeedback()
  return (
    <CurrencyListItem
      pair={undefined}
      onClick={() => {
        if (onCurrencySelect) {
          haptics.impactOccurred('light')
          onCurrencySelect(currency.currency)
        }
      }}
      currency={currency.currency}
      endContent={
        <BalanceContainer>
          <BalanceNative>
            <AmountFormatted
              amount={currency.balance}
              currency={currency.currency.ticker}
              roundingMode="trunc"
            />
          </BalanceNative>
          <BalanceUsd>
            <AmountFormatted
              amount={currency.balanceUsd}
              currency="$"
              roundingMode="trunc"
            />
          </BalanceUsd>
        </BalanceContainer>
      }
    />
  )
}

const BalanceNative = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: var(--text-12);
  text-align: right;
`
const BalanceUsd = styled.div`
  font-weight: 700;
  font-size: 10px;
  text-align: right;
  color: var(--text-9);
`

const BalanceContainer = styled.div`
  display: grid;
  gap: 6px;
`
